import { IAppTheme, defaultAppTheme } from "themes/commonStyles"

export interface IApplicationSetup {
    id: number,
    companyName: string,

    name: string,
    nameAlt: string,
    description: string,
    descriptionAlt: string,

    motto: string,
    mottoAlt: string,

    shortName: string,
    establishmentDate: Date,
    accreditationNumber: string,
    portable1: string,
    portable2: string,
    fax: string,
    landLine1: string,
    landLine2: string,
    email1: string,
    email2: string,
    websiteUrl: string,
    address: string,
    country: string,
    region: string,
    city: string,
    defaultCurrency: string,
    timezone: string,

    currentSchoolYearId: number,
    schoolYearStartDate: Date,
    schoolYearEndDate: Date,

    

    isPasswordComplexityAllowed: boolean,
    passwordDuration: number,
    passwordRotation: number,
    maxAccessFailedCount: number,
    accessLockoutDuration: number,

    applicationApiToken: string,
    websiteApplicationApiToken: string,
    
    whatsAppBaseUrl: string,
    whatsAppIdentityToken: string,
    whatsAppLogin: string,
    whatsAppPasswordMd5: string,

    whatsAppPassword: string,
    isPasswordChanged: boolean,

    webhookToken: string,
    webhookUrl: string,

    smtpServer: string,
    smtpPort: number,
    smtpUsername: string,
    smtpPassword: string,
    smtpSenderEmail: string,
    smtpUseTls: boolean,
    smtpServerType: string,

    certificateSmsExpression: string,

    certificateDocumentExpression: string,
    certificateImageExpression: string,
    certificateQrCodeExpression: string,

    
    
    isSmsOn: boolean,
    isWhatsAppOn: boolean,
    isReportScheduleOn: boolean,
    isFeatureScheduleOn: boolean,
    notificationWhatsAppNumber1: string,
    notificationWhatsAppNumber2: string,

    applicationTheme: IAppTheme
  }


  export const defaultApplicationSetup : IApplicationSetup = {
    id: 0,
    companyName: '',
    name: '',
    nameAlt: '',
    description: '',
    descriptionAlt: '',

    motto: '',
    mottoAlt: '',
    shortName: '',
    establishmentDate: new Date(),
    accreditationNumber: '',
    portable1: '',
    portable2: '',
    fax: '',
    landLine1: '',
    landLine2: '',
    email1: '',
    email2: '',
    websiteUrl: '',
    address: '',
    country: '',
    region: '',
    city: '',
    defaultCurrency: '',
    timezone: '',
    
    currentSchoolYearId: 0,
    schoolYearStartDate: new Date(),
    schoolYearEndDate: new Date(),

    isPasswordComplexityAllowed: false,
    passwordDuration: 0,
    passwordRotation: 0,
    maxAccessFailedCount: 0,
    accessLockoutDuration: 0,

    applicationApiToken: '',
    websiteApplicationApiToken: '',
    
    whatsAppBaseUrl: '',
    whatsAppIdentityToken: '',
    whatsAppLogin: '',
    whatsAppPasswordMd5: '',

    whatsAppPassword: '',
    isPasswordChanged: false,

    webhookToken: '',
    webhookUrl: '',

    smtpServer: '',
    smtpPort: 0,
    smtpUsername: '',
    smtpPassword: '',
    smtpSenderEmail: '',
    smtpUseTls: false,
    smtpServerType: '',

    certificateSmsExpression: '',

    certificateDocumentExpression: '',
    certificateImageExpression: '',
    certificateQrCodeExpression: '',

    isSmsOn: true,
    isWhatsAppOn: true,
    isReportScheduleOn: true,
    isFeatureScheduleOn: true,
    notificationWhatsAppNumber1: '',
    notificationWhatsAppNumber2: '',

    applicationTheme: defaultAppTheme
  }


  export interface IApplicationSetupSearch {
    companyName: string
  }